//ver 1.2 GT ga360	
//kotwice z nawigacji + pv i vpv

var activeSlug;
var isScrolling = false,// gdy strona się scrolluje to zmienna ma wartość true i nie wysyłamy statów na hover np. akordeon, hotpoint
    lastReportedSlug = null;
var wp_content_selector,
    category,
    stickerData,
    animationTime = 1000;

(function () {

    var initSlug = document.location.pathname.split("/").pop();

    if (!document.getElementsByClassName('__js_section').length
       || document.location.href.indexOf('.html') > 0) return;

    activeSlug = initSlug;
    var customOffset = $('.header--nav').height() - 9,
        $sections = $('.__js_section'),

        // Przewijanie do sekcji slug jeżeli w URL jest ustawiony jakiś slug na starcie
        
        scrollOnStart = function () {
            
            $('html,body').animate({
                scrollTop: $('#' + initSlug).offset().top - customOffset + 10 
            }, animationTime, 'easeOutExpo');

            var art_title = $(String(initSlug)).parent().data('id');

            sendStats('progress', 'start', initSlug);

            changeActiveSlug(initSlug);
        },

        // staty pageviews i scrollboost pwp ----- {
        
        reportSlugTS = -1,

        reportSlug = function() {
            if (lastReportedSlug === null) {
                
                //wyślij statystykę pageview standard
                if(typeof(statData)=='undefined' && !statData.length) {
                    console.log('%c brakuje statData lub brak danych do statystyk ga360', 'background: #553311; padding: 3px; color: #ffaaaa');
                    return;
                }
                wp_dot_addparams.ctags = statData[activeSlug].tags;

                window.dataLayer.push({
                    event: "pageview",
                    page: {
                        pageviewType: "standard",
                        error404: basicStatData.ga.page.error404,
                        templateType: "AS"
                    },
                    site: {
                        name: basicStatData.ga.site.name,
                        version: basicStatData.ga.site.version,
                        cms: basicStatData.ga.site.cms,
                        as: asGA30
                    },
                    content: {
                        title: statData[activeSlug].title,
                        category: {
                            IAB: statData[activeSlug].category.IAB,
                            Gemius: statData[activeSlug].category.Gemius
                        },
                        tags: statData[activeSlug].tags
                    }
                });
                
            } else {
                // wyślij statystykę pageview scrolboost vpv. pageviewType ma wartość "overlay" 
                // gdy nie mamy doładowania i "scrollboost" gdy następuje doładowanie, ALE dla pseudo dynamicznych stron AS ma byc jednak scrollboost ;) - ustalone z Salestube !
                
                wp_content_selector = document.getElementById(lastReportedSlug);
                
                WP.stat.show(wp_sn, {"category": 'pageviewVpv', "label": 'scrollboost', "asproduct": asproduct, "asorderid": asorderid, "asname": asname }, 'pageviewVpv');
                //sendStats('pageviewVpv', 'scrollboost', activeSlug); // musi isć dot ptrzed ustawieniem wp_content_selector
                
                unloadData(lastReportedSlug);
                
                if(typeof(statData)=='undefined' && !statData.length) {
                    console.log('%c brakuje statData lub brak danych do statystyk ga360', 'background: #553311; padding: 3px; color: #ffaaaa');
                    return;
                }
                
                wp_dot_addparams.ctags = statData[activeSlug].tags;

                window.dataLayer.push({
                    event: "pageviewVpv",
                    page: {
                        pageviewType: "scrollboost",
                        error404: basicStatData.ga.page.error404,
                        templateType: "AS"
                    },
                    site: {
                        name: basicStatData.ga.site.name,
                        version: basicStatData.ga.site.version,
                        cms: basicStatData.ga.site.cms,
                        as: asGA30,
                        frontendPlatform: "other"
                    },
                    content: {
                        title: statData[activeSlug].title,
                        category: {
                            IAB: statData[activeSlug].category.IAB,
                            Gemius: statData[activeSlug].category.Gemius
                        },
                        tags: statData[activeSlug].tags
                    }
                });
            }
            
            lastReportedSlug = activeSlug;
            reportSlugTS = -1;
        },
        
        // ----- }
        
        changeActiveSlug = function(slug) {

            activeSlug = slug;

            if ( getActiveSlugIndex()==0 ) {
                //slug = "/";
                $('.header--nav ul').attr('class', 'order_'+0); // == 0;
            }

            /* zmiana klas w nawigacji - css pokazuje tylko pierwsze z kategorii */
            $('.header--nav [data-slug]').removeClass("__active");
            $('.header--nav [data-slug]').parents('li').removeClass("__active");
            $('.header--nav [data-slug]').parents('li').removeClass("__activeItem");
            $('.header--nav [data-category]').removeClass("__activeCategory");
            
            $('.additional-nav--wrapper [data-slug]').removeClass("__active");

            $('.header--nav [data-slug='+activeSlug+']').addClass("__active");
            $('.header--nav [data-slug='+activeSlug+']').parents('li').addClass("__activeItem");

            $('.additional-nav--wrapper [data-slug='+activeSlug+']').addClass("__active");
            
            category = $('.header--nav [data-slug='+activeSlug+']').parents('li').data('category');
            stickerData = $('.header--nav [data-slug='+activeSlug+']').parents('li').data('sticker');
            
            $('.header--nav [data-category='+category+']').addClass("__activeCategory");
            
            $('.header--nav ul').attr('class', 'order_'+getActiveSlugIndex());
            
            /* sprawdzenie czy zmienić metkę przy zmianie kategorii */
            if(typeof chageStickyLogo !== "undefined") {
                chageStickyLogo(stickerData);
            }
            
            
            history.pushState({
                id: slug
            }, $(this).attr('title'), slug + ((document.location.search.length>-1)? document.location.search:'') );
            
            
//          history.pushState({  //title
//               id: slug
//          }, slug , slug + ((document.location.search.length>-1)? document.location.search:'') );

            
            if (lastReportedSlug === null) { // jeżeli pierwsze wejście to wysyłaj pageview od razu
                reportSlug();
                
            } else if (lastReportedSlug != slug) { // jeżeli zmiana sluga to wysyłaj po sekundzie statystykę
                                
                if (reportSlugTS >-1 ) clearTimeout(reportSlugTS);
                reportSlugTS = setTimeout(reportSlug, 1000);
                
            } else {
                if (reportSlugTS >-1 ) clearTimeout(reportSlugTS);   
            }
        },

        // Sprawdzanie numeru sluga, domyślnie aktualnego
        getActiveSlugIndex = function(slug){
            if (!slug) slug = activeSlug;
            return $('.header--nav [data-slug='+slug+']').parent().parent().index();
        },

        // Sprawdzanie czy user zescrollował do sekcji. Jeżeli tak to ustawia pozycję w nawigacji
        sectionScrollCheck = function(){

            sectionScrollCheckTS = setTimeout(sectionScrollCheck, 200);

            var $W = $(window),
                topScroll = $W.scrollTop(),
                wHeight = $W.height();

            // wymuszenie strony głównej
            if (topScroll <= customOffset) {
                changeActiveSlug($sections.eq(0).attr('id'));
                return;
            }

            for (var i=0; i<$sections.length; i++) {
                var $section = $sections.eq(i),
                    sectionOffset = $section.offset().top,
                    sectionHeight = $section.height();
                   
                if (activeSlug != $section.attr('id') &&
                    topScroll > sectionOffset - customOffset - 10 &&
                    topScroll < sectionOffset + sectionHeight - customOffset ) {
                        
                        
                        changeActiveSlug($section.attr('id'));
                        
                        break;
                }

            }
        },
        sectionScrollCheckTS = null,

        // Inicjalizacja metod dla obsługi nawigacji - clików i sprawdzanie scrolla, dodanie flagi podczas skrolowania
        initNavigation = function () {
            
            
                sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25 );
            
                $('.header--nav [data-slug].__inactive, #additionalNav [data-slug].__inactive').on('click', function (e) {
                    // inactive - kategoria wkrótce
                    e.preventDefault();
                    return;
                });
            
                /* dotyczy kalendarza z tygodniami lub lub dodatkowej nawigacji po kategoriach */
                $('.header--nav [data-slug]:not([href^="tydzien-" i]):not(.__inactive), #additionalNav [data-slug]:not(.__inactive)').on('click', function (e) { 
                    
                    isScrolling = true;

                    //console.log('slug: ' + slug + ', activeSlug: ' + activeSlug + ', lastReportedSlug: ' + lastReportedSlug);

                    if (sectionScrollCheckTS) clearTimeout(sectionScrollCheckTS);

                    e.preventDefault();
                    var $this = $(this),
                        slug = $(this).data('slug');
                    if (!slug.length) slug = "/";

                    changeActiveSlug(slug);

                    if($(this).data('slug') !== activeSlug){
                        $('html,body').animate({
                        scrollTop: getActiveSlugIndex()>0?$('#' + slug).offset().top - customOffset + 10: 0
                        }, animationTime, 'easeInOutExpo', function(){ isScrolling = false; });
                        sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25); 
                        // przewinięcie głównego zdjęcia po autoscrollu z nawigacji
                        // $('html,body').delay(170).animate({scrollTop: $('#' + slug).find('h1').offset().top - 100 }, 820, 'easeInOutExpo');

                    } else {
                         $('html,body').animate({ scrollTop: $('#' + slug).offset().top - customOffset + 10
                        }, animationTime - 300, 'easeInOutExpo', function(){ isScrolling = false; });


                        sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25); 
                        // $('html,body').delay(170).animate({scrollTop: $('#' + slug).find('h1').offset().top - 100 }, 820, 'easeInOutExpo');
                    };

                });
                $('.header--nav [href^="tydzien-" i]').on('click', function (e) { //klik w przyszły tydzień
                    e.preventDefault();
                    return;
                });
            
        };

    if (initSlug.length > 1 ) {
        setTimeout(scrollOnStart, 800);
    }
    
    
    initNavigation();
    
    
})();